import { publicApiClient, authApiClient } from './api';

export const fetchQuestionnaires = async () => {
  try {
    const response = await publicApiClient.get('');
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.status === 401
        ? 'دسترسی غیرمجاز: لطفاً دوباره امتحان کنید.'
        : 'خطا در دریافت پرسشنامه‌ها'
    );
  }
};

export const getQuestionnaireDetails = async (id) => {
  try {
    const response = await publicApiClient.get(`${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.status === 401
        ? 'دسترسی غیرمجاز: لطفاً دوباره امتحان کنید.'
        : 'خطا در دریافت جزئیات پرسشنامه'
    );
  }
};

export const submitQuestionnaire = async (id, answers) => {
  try {
    const response = await authApiClient.post(`${id}/submit/`, answers);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.status === 401
        ? 'دسترسی غیرمجاز: لطفاً وارد شوید.'
        : error.response?.status === 403
        ? 'شما اجازه ارسال این پرسشنامه را ندارید.'
        : 'خطا در ارسال پرسشنامه'
    );
  }
};

export const updateWhatsAppStatus = async (submissionId) => {
  try {
    const response = await authApiClient.post(`/submission/update-whatsapp-status/`, {
      whatsapp_status: 'requested'
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error('دسترسی غیرمجاز: لطفاً وارد شوید.');
    }
    throw new Error(error.response?.data?.message || 'خطا در بروزرسانی وضعیت واتس اپ');
  }
};